<template>
  <div class="bg-white py-5 px-4 d-flex justify-space-between">
    <template v-for="(label, index) in labels">
      <v-divider v-if="index" :key="`divider-${index}`" class="mt-4" />
      <div :key="label" class="text-center px-2">
        <p class="step-circle bg-silver text-heading --white mx-auto" :class="{ 'bg-primary': stage === index + 1 }">{{ index + 1 }}</p>
        <p class="mt-2 text-default --black" :class="{ '--prm': stage === index + 1 }">{{ label }}</p>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  props: { stage: { type: Number, required: true } },
  computed: {
    labels () {
      return ['情報入力', this.$t('text.stage.confirmation'), this.$t('text.stage.complete')]
    }
  }
}
</script>

<style scoped>
.step-circle {
  width: 33px;
  height: 33px;
  border-radius: 50%;
}
</style>
